import React, { Component } from 'react';
import { Row, Col, Modal, Icon } from 'antd';

export default class PageLoadingIndicator extends Component {
    constructor(props) { super(props); }
    render() {
        const { loading } = this.props;
        return (
            <div>
                <Modal
                    closable={false}
                    maskClosable={false}
                    footer={null}
                    visible={!(loading.find(l => (l != null)))}
                    width={300}
                    style={{
                        position: 'absolute',
                        transform: 'translate(-50%, -50%)',
                        top: '57%',
                        left: '50%'
                    }}
                >
                    <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', fontStyle: 'italic' }}>
                        <Icon type='loading' style={{ marginRight: '10px' }}/>
                        {'Loading...'}
                    </div>
                </Modal>
            </div>
        )
    }
}
